import { ContentAuthor } from '../types';
import headshot from '../assets/treyoverton.jpg';

const bio = (
  <div className='flex flex-col gap-4 italic'>
    <p>
      Software engineer and architect across myriad industries, building web properties from the very beginning in the 1990s; Did a great
      stint at Microsoft; Game designer of tabletop miniature wargames, Shock Force and GWAR: Rumble in Antarctica; Officer in the Tennessee
      State Guard.
    </p>
  </div>
);

export const Author: ContentAuthor = {
  name: 'Trey Overton',
  title: 'CTO',
  email: 'trey@playcast.io',
  headshot: headshot,
  bio: bio,
};
